var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row pt-1" }, [
      _c("div", { staticClass: "col-sm-1" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("span", { staticClass: "data-name font-weight-normal" }, [
              _vm._v("Año Fiscal:")
            ]),
            _c("p", { staticClass: "data font-weight-normal" }, [
              _vm._v(" " + _vm._s(_vm.model.fiscalYearDescription) + " ")
            ])
          ])
        ]),
        (_vm.model.amendments || []).length > 0 && !_vm.isChild
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "span",
                  { staticClass: "color-primary-2 font-weight-normal" },
                  [
                    _vm._v(
                      " (" +
                        _vm._s(_vm.model.amendments.length) +
                        ") Enmienda(s) "
                    )
                  ]
                )
              ])
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "col-sm-3 col-contract-number" }, [
        _c("span", { staticClass: "data-name font-weight-normal" }, [
          _vm._v("Número de Contrato:")
        ]),
        _vm.editingNumbers && _vm.isChild
          ? _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c("span", { staticClass: "font-weight-bold mr-1" }, [
                  _vm._v(_vm._s(_vm.numberValue) + "-")
                ]),
                _c("custom-input", {
                  staticStyle: { "max-width": "50px" },
                  attrs: {
                    maxlength: "1",
                    name: "contractNumberSuffixEdit",
                    value: _vm.numberSuffix
                  },
                  on: {
                    input: function($event) {
                      _vm.$emit(
                        "update-number-suffix",
                        $event.slice(0, 1).toUpperCase()
                      )
                    }
                  }
                })
              ],
              1
            )
          : _vm.editingNumbers
          ? _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c("custom-input", {
                  attrs: { name: "contractNumberEdit", value: _vm.numberValue },
                  on: {
                    input: function($event) {
                      return _vm.$emit("update-number", $event)
                    }
                  }
                }),
                _vm.canEditNumber
                  ? _c("action-button", {
                      staticClass: "ml-2 number-edit-btn",
                      attrs: {
                        i: "fas fa-save",
                        title: "Guardar",
                        variant: "outline-success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("save-numbers")
                        }
                      }
                    })
                  : _vm._e(),
                _vm.canEditNumber
                  ? _c("action-button", {
                      staticClass: "ml-2 number-edit-btn",
                      attrs: {
                        i: "fas fa-times",
                        title: "Cancelar",
                        variant: "outline-secondary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("cancel-edit-numbers")
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _c("p", { staticClass: "data font-weight-normal" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.model.contractNumber ? _vm.model.contractNumber : "-"
                  ) +
                  " "
              ),
              _vm.canEditNumber
                ? _c("em", {
                    staticClass: "fas fa-edit color-primary-1 ml-1",
                    staticStyle: { cursor: "pointer" },
                    attrs: { title: "Editar número de contrato" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("toggle-edit-numbers")
                      }
                    }
                  })
                : _vm._e()
            ])
      ]),
      _c("div", { staticClass: "col-sm-2 col-status" }, [
        _c("span", { staticClass: "data-name font-weight-normal" }, [
          _vm._v("Estatus:")
        ]),
        _c(
          "p",
          { staticClass: "data font-weight-normal" },
          [
            _c("status-badge", {
              attrs: {
                title:
                  _vm.model.isSignedFlag === true ? "Firmado" : "No firmado",
                type: _vm.model.isSignedFlag === true ? "success" : "none"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "col-sm" }, [
        _c("span", { staticClass: "data-name font-weight-normal" }, [
          _vm._v(" Fecha Comienzo/Finalización: ")
        ]),
        _c("p", { staticClass: "data font-weight-normal" }, [
          _vm._v(" " + _vm._s(_vm.getStartEndDate(_vm.model)) + " ")
        ])
      ]),
      _vm.model.isDirectPayment
        ? _c("div", { staticClass: "col-sm-2 mt-2" }, [
            _c(
              "span",
              {
                staticClass: "badge badge-pill badge p-2 px-2",
                class: `border-color--green`,
                staticStyle: { "background-color": "#e3ffe9" }
              },
              [
                _c("em", { class: `fas fa-dollar-sign color-green` }),
                _c(
                  "span",
                  {
                    staticClass: "font-weight-bold ml-1",
                    class: `color-green`
                  },
                  [_vm._v(" Pago Directo ")]
                )
              ]
            )
          ])
        : _c("div", { staticClass: "col-sm-2" }, [
            _c("span", { staticClass: "data-name font-weight-normal" }, [
              _vm._v("Monto:")
            ]),
            _c("p", { staticClass: "data font-weight-normal" }, [
              _vm._v(
                " " + _vm._s(_vm._f("price")(_vm.model.balanceMaxAmt)) + " "
              )
            ])
          ]),
      _c("div", { staticClass: "col-sm-1" }, [
        !_vm.isChild
          ? _c("span", { staticClass: "data-name font-weight-normal" }, [
              _vm._v("Total:")
            ])
          : _vm._e(),
        !_vm.isChild
          ? _c("p", { staticClass: "data font-weight-normal" }, [
              _vm._v(" " + _vm._s(_vm._f("price")(_vm.totalBalance)) + " ")
            ])
          : _vm._e()
      ]),
      _c(
        "div",
        { staticClass: "col-sm text-center" },
        [
          _c("drop-down", {
            class: { "ml-3": _vm.isChild },
            attrs: {
              "data-item": _vm.model,
              items: _vm.getAvailableActions(_vm.model)
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }